"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Contact_1 = require("../Contact");
const CommonBaseError_1 = require("../../Common/CommonBaseError");
const TypeScriptUtils_1 = require("../../Common/TypeScriptUtils");
class UserUtils {
    static HasContact(contacts, aUserId) {
        if (!aUserId)
            return false;
        return contacts.findIndex(c => c.id === aUserId) >= 0;
    }
    static ContactOfId(contacts, aUserId) {
        if (!aUserId)
            throw new UserUtilsError(`Invalid aUserId=${aUserId}`);
        return contacts.find(c => c.id === aUserId) || Contact_1.Contact.Nobody;
    }
    static HasAddedContact(contacts, aUserId) {
        if (!aUserId)
            return false;
        return contacts.findIndex(c => (c.id === aUserId) && (c.status === Contact_1.ContactStatus.Added)) >= 0;
    }
    static IsFavoriteContact(contacts, aUserId) {
        if (!aUserId)
            return false;
        return contacts.findIndex(c => (c.id === aUserId) && c.isFavorite) >= 0;
    }
    static FavoriteContactOfId(contacts, aUserId) {
        if (!aUserId)
            throw new UserUtilsError(`Invalid aUserId=${aUserId}`);
        return contacts.find(c => (c.id === aUserId) && c.isFavorite) || Contact_1.Contact.Nobody;
    }
    static IsValid(userid, username) {
        return !TypeScriptUtils_1.isNullOrEmpty(userid) && !TypeScriptUtils_1.isNullOrEmpty(username);
    }
}
exports.UserUtils = UserUtils;
exports.UserUtilsErrorName = "UserError";
class UserUtilsError extends CommonBaseError_1.CommonBaseError {
}
exports.UserUtilsError = UserUtilsError;
//# sourceMappingURL=UserUtils.js.map